goog.provide("shadow.js.shim.module$date_fns$locale$ko$default");
shadow.js.shim.module$date_fns$locale$ko$default = esm_import$date_fns$locale$ko.default;
